/**
 * @author Ariel
 * @date 2021-12-24
 * @desc 短视频举报列表页配置
 */
import React from 'react'
import { component_tool } from '../../../../tool';
import { WizTableForm } from "../../../common";

let { WizDataTable, WizButton, WizModal } = component_tool
let componentName = 'shortVideoScreen'

const labelConfig = WizTableForm.Config.shortVideoLabel(this, { apiParams: { type: 6 } })

const columns = (_handleLook) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'shortVideoId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '标题',
      name: 'title',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '标签',
      name: 'labelId',
      searchItem: {
        ...labelConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '发布人',
      name: 'fullName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '帐号',
      name: 'userName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '发布时间',
      name: 'releaseTime',
      tableItem: {}
    },
    {
      title: '举报数',
      name: 'screenNum',
      tableItem: {}
    },
    {
      title: '处理状态',
      name: 'state',
      tableItem: {},
      searchItem: { type: 'select' },
      dict: [
        { code: 0, codeName: '待处理' },
        { code: 1, codeName: '已屏蔽' },
        { code: 2, codeName: '无需处理' }
      ]
    },
    {
      title: '屏蔽类型',
      name: 'type',
      tableItem: {},
      searchItem: { type: 'select' },
      dict: [
        { code: 1, codeName: '违法违规' },
        { code: 2, codeName: '色情低俗' },
        { code: 3, codeName: '诈骗信息' },
        { code: 4, codeName: '低差广告' },
        { code: 5, codeName: '虚假不实' },
        { code: 6, codeName: '搬运抄袭' },
        { code: 7, codeName: '谩骂攻击' },
        { code: 8, codeName: '涉未成年人' },
        { code: 9, codeName: '时政不实信息' },
        { code: 10, codeName: '引人不适' },
        { code: 11, codeName: '诱导关注点赞' },
        { code: 12, codeName: '侵权投诉' },
        { code: 999, codeName: '其他' },
      ]
    },
    {
      title: '处理原因',
      name: 'remark',
      tableItem: {}
    },
    {
      title: '处理证据',
      name: 'files',
      tableItem: {
        render: (text, row) => (
          <WizButton disabled={!text} type='link' onClick={() => _handleLook(text)}>
            查看
          </WizButton>
        )
      }
    },
  ];
}

const templateConfig = (_handlePreview, _handleLook) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(_handleLook),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['preview', 'recordManagement', 'update'],
        rowOperateView: [
          {
            key: "preview",
            name: 'WizButton',
            params: {
              children: '预览',
              key: '_btn',
              type: 'primary',
            },
            onClick: ({ record }) => { _handlePreview(record) },
          },
          {
            key: "recordManagement",
            custom: true,
            params: { children: "举报记录" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/shortVideoScreen/record"
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: { children: "处理" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/shortVideoScreen/toDeal"
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let is = record.state !== 0
              return { hidden: is }
            },
          },
        ],
        commonOperate: {
        }
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
}

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
